import React from 'react';
import WebBasic from 'views/Menstrual';

const WebBasicPage = () => {
  return <WebBasic />;
};

export default WebBasicPage;